import { render, staticRenderFns } from "./QuotationHistoryPage.vue?vue&type=template&id=4545ef03&scoped=true"
import script from "./QuotationHistoryPage.vue?vue&type=script&lang=js"
export * from "./QuotationHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./QuotationHistoryPage.vue?vue&type=style&index=0&id=4545ef03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4545ef03",
  null
  
)

export default component.exports